import { render, staticRenderFns } from "./edit - 副本.vue?vue&type=template&id=5aa2c979&scoped=true&"
import script from "./edit - 副本.vue?vue&type=script&lang=js&"
export * from "./edit - 副本.vue?vue&type=script&lang=js&"
import style0 from "./edit - 副本.vue?vue&type=style&index=0&id=5aa2c979&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2c979",
  null
  
)

export default component.exports